import { useState, useRef, useEffect } from "react"
import { Paper, Box, Typography, TextField, Button, List, ListItem, IconButton } from "@mui/material"
import theme from "./theme"
import intentsData from "./data/intents.json"
import CloseIcon from "@mui/icons-material/Close"
import SwissnexLogo  from './assets/swissnex-logo.png'
import stringSimilarity from "string-similarity"
import { styled } from "@mui/material/styles"

const Bubble = styled(Box, {
  shouldForwardProp: (prop) => prop !== "from"
})(({ from, theme }) => ({
  position: "relative",
  background: from === "user" ? "#E7343F" : "#EDEDED",
  color: from === "user" ? "#fff" : "#222",
  padding: "12px 18px",
  borderRadius: "18px",
  maxWidth: "80%",
  boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
  wordBreak: "break-word",
  marginLeft: from === "user" ? "auto" : 0,
  marginRight: from === "user" ? 0 : "auto",
  marginBottom: 4,
  "&::after": {
    content: '""',
    position: "absolute",
    transform: from === "user"
      ? "translateY(-50%) scaleX(-1)"
      : "translateY(-50%)",
    top: "50%",
    left: from === "user" ? "unset" : "-10px",
    right: from === "user" ? "-9px" : "unset",
    width: 0,
    height: 0,
    borderStyle: "solid",
    borderWidth: "10px 10px 10px 0",
    borderColor: `transparent ${from === "user" ? "#E7343F" : "#EDEDED"} transparent transparent`,
    display: "block"
  }
}))




export default function Chatbot({ onClose }) {
  const [messages, setMessages] = useState([
    { from: "bot", text: "Hi! I’m your Swissnex Boston bot. Ask me anything about Boston, Swissnex, housing, transport or sightseeing." }
  ])
  const [input, setInput] = useState("")
  const listRef = useRef(null)

  useEffect(() => {
    if (listRef.current)
      listRef.current.scrollTop = listRef.current.scrollHeight
  }, [messages])

    function getAnswer(text) {
    const input = text.toLowerCase()
    let bestIntent = null
    let bestScore = 0

    for (let intent of intentsData) {
        for (let pattern of intent.patterns) {
        const score = stringSimilarity.compareTwoStrings(input, pattern.toLowerCase())
        if (score > bestScore) {
            bestScore = score
            bestIntent = intent
        }
        }
    }

    if (bestScore > 0.45 && bestIntent) {
        const answers = bestIntent.answers
        const answer = answers[Math.floor(Math.random() * answers.length)]
        // Rückgabe als Objekt: {text, image}
        if (typeof answer === "string") return { text: answer }
        return answer
    }
    return { text: "I can only answer questions related to Swissnex Boston – and I’m afraid I don’t have a response to this specific topic." }
    }

  function handleSend() {
    if (!input.trim()) return
    const reply = getAnswer(input)
    setMessages(msgs => [
    ...msgs,
    { from: "user", text: input },
    { from: "bot", ...reply }
    ])
    setInput("")
  }

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: theme.borderRadius,
        bgcolor: theme.secondaryColor,
        fontFamily: theme.fontFamily,
        boxShadow: 4,
        minHeight: 350,
        maxHeight: 500,
        display: "flex",
        flexDirection: "column"
      }}
      aria-label="Chatbot"
    >
      <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
       <img src={SwissnexLogo} alt="Swissnex Logo" style={{ height: 40 }} />

        <Typography variant="h6" sx={{ color: theme.primaryColor, fontWeight: 700, flex: 1 }}>
          Boston-Chatbot
        </Typography>
        {onClose && (
          <IconButton aria-label="Close" onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      <Box
        ref={listRef}
        sx={{
          flex: 1,
          overflowY: "auto",
          mb: 1,
          px: 0.5,
          bgcolor: "#fff",
          borderRadius: 2
        }}
        tabIndex={0}
        aria-live="polite"
      >
        <List>
          {messages.map((msg, i) => (
            <ListItem
              key={i}
               sx={{
                justifyContent: msg.from === "user" ? "flex-end" : "flex-start",
                py: 0.5,
                background: "none"
            }}
            >
            <Bubble from={msg.from}>
                {msg.text}
                {msg.image && (
                <img
                src={`/img/${msg.image}`}
                alt=""
                style={{ maxWidth: 180, display: "block", marginTop: 8, borderRadius: 8 }}
                />
            )}
              </Bubble>
            </ListItem>
          ))}
        </List>
      </Box>
<Box sx={{ display: "flex", gap: 0, alignItems: "center", mt: 1 }}>
  <TextField
    value={input}
    onChange={e => setInput(e.target.value)}
    size="small"
    fullWidth
    onKeyDown={e => { if (e.key === "Enter") handleSend() }}
    placeholder="Type your question..."
    inputProps={{ "aria-label": "Type your question..." }}
    sx={{
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      background: "#fff"
    }}
  />
  <Button
    onClick={handleSend}
    variant="contained"
    sx={{
      bgcolor: theme.primaryColor,
      borderTopRightRadius: 8,
      borderBottomRightRadius: 8,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      minWidth: 70,
      height: "38px",
      "&:hover": { bgcolor: "#C1222B" }
    }}
    tabIndex={0}
  >
    SEND
  </Button>
</Box>

    </Paper>
  )
}

